import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState, type ReactNode } from "react";
import { cx } from "../cx";

const Ctx = createContext<(msg: string) => void>(() => {});
/** Lo que tarda la píldora en irse (--sk-t-slow): el nodo aguanta hasta el final. */
const SALIDA = 400;
/** Host único de toasts (sk-toast-host) + `useToast()` para decir algo. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState<string | null>(null);
  /** Lo último dicho: se conserva mientras la píldora se desliza fuera. */
  const [eco, setEco] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);
  const salida = useRef<number | undefined>(undefined);
  const say = useCallback((m: string) => {
    window.clearTimeout(salida.current);
    setEco(m);
    setMsg(m);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      setMsg(null);
      salida.current = window.setTimeout(() => setEco(null), SALIDA);
    }, 2600);
  }, []);
  useEffect(() => () => { window.clearTimeout(timer.current); window.clearTimeout(salida.current); }, []);
  const value = useMemo(() => say, [say]);
  return (
    <Ctx.Provider value={value}>
      {children}
      {/* cerrada = SIN contenido: el host solo se traslada fuera de la vista,
          así que una píldora con el glifo y sin texto se quedaba a la vista en
          las capturas de página completa. Pero el nodo aguanta la SALIDA, o la
          píldora desaparecería de golpe. El glifo es el `✳` del sistema. */}
      <div className={cx("sk-toast-host", msg !== null && "sk-open")} role="status" aria-live="polite">
        {eco !== null && <div className="sk-toast"><span className="sk-toast-i">✳</span><span>{eco}</span></div>}
      </div>
    </Ctx.Provider>
  );
}
export const useToast = () => useContext(Ctx);
